import { defineStore } from 'pinia'
import { useAgentStore } from './agent'
import { useAuthStore } from '~/stores/auth'
import type { CurrentUpdates, EventShort, Update, Slide } from '~/types/events'
import type { TableQueryPayload } from '~/types/demo'
import { filterTableUrlParams } from '~/utils'

export const useEventStore = defineStore('events', {
  state: () => ({
    slides: [] as Slide[],
    events: [] as EventShort[],
    currentUpdates: { news: { }, totalPages: 0, totalResults: 0 } as CurrentUpdates,
    updates: [] as Update[]
  }),
  actions: {
    async querySlides () {
      const agentStore = useAgentStore()
      const authStore = useAuthStore()
      const { isDemo } = useSAuthState()
      if (isDemo.value || authStore.isAgent) {
        const viewAsDate = agentStore.viewAsDate
        const query = viewAsDate ? { viewAsDate } : undefined
        const data = await $api()<Slide[]>('/content/demo/slides', { query })
        this.$state.slides = data
      }
    },
    async queryUpdates (limit: number = 7) {
      const agentStore = useAgentStore()
      const authStore = useAuthStore()
      const { isDemo } = useSAuthState()
      if (isDemo.value || authStore.isAgent) {
        const viewAsDate = agentStore.viewAsDate
        const query = viewAsDate ? { count: limit, viewAsDate } : { count: limit }
        const data = await $api()<Update[]>('/content/demo/news', { query })
        this.$state.updates = data
      }
    },
    async queryCurrentUpdates (query: TableQueryPayload) {
      const agentStore = useAgentStore()
      const authStore = useAuthStore()
      const { isDemo } = useSAuthState()
      if (isDemo.value || authStore.isAgent) {
        const viewAsDate = agentStore.viewAsDate
        const params = filterTableUrlParams(query)
        if (params.orderBy) {
          params.month = params.orderBy
          delete params.orderBy
        }
        const parsedQuery = viewAsDate ? { ...params, viewAsDate } : { ...params }
        const data = await $api()<CurrentUpdates>('/content/demo/current-updates', { query: parsedQuery })
        this.$state.currentUpdates = data
      }
    },
    async queryEvents (month?: number, year?: number) {
      const agentStore = useAgentStore()
      const authStore = useAuthStore()
      const { isDemo } = useSAuthState()
      if (isDemo.value || authStore.isAgent) {
        const viewAsDate = agentStore.viewAsDate
        const parsedQuery = viewAsDate ? { month, year, viewAsDate } : { month, year }
        const data = await $api()<EventShort[]>('/content/demo/calendar', { query: parsedQuery })
        this.$state.events = data
      }
    }
  }
})
